"use client";

import React, { useState } from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight, Thermometer, Zap, Activity, Wind, Settings, Droplets } from "lucide-react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const categories = ["Todos", "Chillers", "Fan Coils", "Climatização de Precisão", "Unidades de Tratamento"];
const products = [{
  id: "prod-1",
  category: "Chillers",
  name: "Chiller Medical Line",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/chiller_medical_mri_scanner.png",
  description: "Resfriamento de alta precisão projetado especificamente para ressonância magnética e equipamentos de diagnóstico por imagem."
}, {
  id: "prod-2",
  category: "Chillers",
  name: "Chiller Industrial Heavy-Duty",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/industrial_chiller_unit_factory.png",
  description: "Solução robusta para processos industriais contínuos, com alta eficiência energética e controle de temperatura estável."
}, {
  id: "prod-3",
  category: "Climatização de Precisão",
  name: "Data Center Precision AC",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/precision_air_conditioner_server_room.png",
  description: "Controle rigoroso de temperatura e umidade para ambientes de missão crítica, servidores e salas de telecomunicações."
}, {
  id: "prod-4",
  category: "Fan Coils",
  name: "Fan Coil Hospitalar Higiênico",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/fan_coil_unit_hospital_ceiling.png",
  description: "Unidades terminais com filtragem avançada (HEPA) e fácil higienização para ambientes estéreis e salas limpas."
}, {
  id: "prod-5",
  category: "Unidades de Tratamento",
  name: "UTA Modular Farmacêutica",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/air_handling_unit_pharmaceutical.png",
  description: "Unidade de Tratamento de Ar modular com controle total de contaminação, pressão e umidade para indústria farmacêutica."
}, {
  id: "prod-6",
  category: "Chillers",
  name: "Chiller Scroll Modular",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/modular_scroll_chiller_rooftop.png",
  description: "Sistema expansível e flexível, ideal para retrofits e ampliações de capacidade em edifícios comerciais e hospitalares."
}];
const productSpecs = [{
  productId: "prod-1",
  icon: "Thermometer",
  label: "Estabilidade",
  value: "±0.1°C"
}, {
  productId: "prod-1",
  icon: "Zap",
  label: "Capacidade",
  value: "5TR - 50TR"
}, {
  productId: "prod-1",
  icon: "Settings",
  label: "Controle",
  value: "PLC Dedicado"
}, {
  productId: "prod-2",
  icon: "Thermometer",
  label: "Faixa Oper.",
  value: "-5°C a 20°C"
}, {
  productId: "prod-2",
  icon: "Zap",
  label: "Capacidade",
  value: "20TR - 400TR"
}, {
  productId: "prod-2",
  icon: "Droplets",
  label: "Refrigerante",
  value: "R-410A / R-134a"
}, {
  productId: "prod-3",
  icon: "Wind",
  label: "Vazão de Ar",
  value: "2.000 - 30.000 m³/h"
}, {
  productId: "prod-3",
  icon: "Droplets",
  label: "Umidade",
  value: "Controle Ativo"
}, {
  productId: "prod-3",
  icon: "Activity",
  label: "Monitoramento",
  value: "SNMP / Modbus"
}, {
  productId: "prod-4",
  icon: "Wind",
  label: "Filtragem",
  value: "G4 + F9 + HEPA"
}, {
  productId: "prod-4",
  icon: "Zap",
  label: "Motor",
  value: "EC Inverter"
}, {
  productId: "prod-4",
  icon: "Settings",
  label: "Ruído",
  value: "Baixo (<45dB)"
}, {
  productId: "prod-5",
  icon: "Wind",
  label: "Vazão",
  value: "Até 100.000 m³/h"
}, {
  productId: "prod-5",
  icon: "Settings",
  label: "Estrutura",
  value: "Painel Duplo 50mm"
}, {
  productId: "prod-5",
  icon: "Droplets",
  label: "Higienização",
  value: "Cantos Arredondados"
}, {
  productId: "prod-6",
  icon: "Zap",
  label: "Eficiência",
  value: "EER > 3.2"
}, {
  productId: "prod-6",
  icon: "Settings",
  label: "Compressor",
  value: "Scroll Digital"
}, {
  productId: "prod-6",
  icon: "Activity",
  label: "Conectividade",
  value: "BMS Nativo"
}];
const getIcon = (iconName: string) => {
  switch (iconName) {
    case "Thermometer":
      return <Thermometer className="size-4 text-primary" />;
    case "Zap":
      return <Zap className="size-4 text-primary" />;
    case "Activity":
      return <Activity className="size-4 text-primary" />;
    case "Wind":
      return <Wind className="size-4 text-primary" />;
    case "Settings":
      return <Settings className="size-4 text-primary" />;
    case "Droplets":
      return <Droplets className="size-4 text-primary" />;
    default:
      return <Activity className="size-4 text-primary" />;
  }
};
export default function LinhasDeProduto() {
  const [activeCategory, setActiveCategory] = useState("Todos");
  const filteredProducts = activeCategory === "Todos" ? products : products.filter(p => p.category === activeCategory);
  return <section id="linhas-de-produto" className="relative w-full py-20 bg-muted/30 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} />

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
            Linhas de Produto
          </h2>
          <p className="text-lg text-muted-foreground">
            Equipamentos de alta performance desenvolvidos com engenharia de precisão para atender aos requisitos mais rigorosos de ambientes críticos.
          </p>
        </div>

        {}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories.map((category, i) => <Button key={category} data-index={i} variant={activeCategory === category ? "default" : "outline"} onClick={() => setActiveCategory(category)} className="rounded-full px-6 transition-all duration-300">
              {category}
            </Button>)}
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product, i) => {
          const specs = productSpecs.filter(s => s.productId === product.id);
          return <Card key={product.id} data-index={i} className="flex flex-col h-full border-border/60 shadow-sm hover:shadow-md transition-shadow duration-300 bg-card">
                {}
                <div className="relative h-56 w-full bg-muted/50 overflow-hidden rounded-t-xl border-b border-border/50 group">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent z-10" />
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute top-4 left-4 z-20">
                    <span className="inline-flex items-center rounded-md bg-background/90 px-2.5 py-0.5 text-xs font-medium text-foreground shadow-sm backdrop-blur-sm border border-border/50">
                      {product.category}
                    </span>
                  </div>
                </div>

                <CardHeader className="pb-2">
                  <CardTitle className="text-xl font-bold text-foreground">
                    {product.name}
                  </CardTitle>
                  <CardDescription className="line-clamp-2 min-h-[2.5rem]">
                    {product.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="flex-grow">
                  <div className="grid grid-cols-1 gap-3 mt-2">
                    {specs.map((spec, j) => <div key={`${product.id}-spec-${j}`} data-index={j} className="flex items-center justify-between text-sm p-2 rounded-lg bg-muted/40 border border-border/40">
                        <div className="flex items-center gap-2 text-muted-foreground">
                          {getIcon(spec.icon)}
                          <span>{spec.label}</span>
                        </div>
                        <span className="font-medium text-foreground">{spec.value}</span>
                      </div>)}
                  </div>
                </CardContent>

                <CardFooter className="pt-2 pb-6">
                  <Button asChild className="w-full group" size="lg">
                    <Link to="/ContactPage">
                      Solicitar Orçamento
                      <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>

        {}
        {filteredProducts.length === 0 && <div className="text-center py-20">
            <p className="text-muted-foreground text-lg">Nenhum produto encontrado nesta categoria.</p>
            <Button variant="link" onClick={() => setActiveCategory("Todos")} className="mt-4">
              Ver todos os produtos
            </Button>
          </div>}
      </div>
    </section>;
}